import React from "react";
import { Link } from "react-router-dom";
import logo from "../Images/brand/logo.png"
import organolepticImg from "../Images/organoleptic_profile_surveys.png"

import Dropdown from "../Components/Common/Dropdown";
import RangeBar from "../Components/Common/RangeBar";

function Organoleptic (){
    return <div className="flex flex-col h-full antialiased bg-neutral-800">
        <header className="sticky top-0 z-50 bg-white md:px-24 drop-shadow-md">
            <div className="flex flex-col items-center justify-between gap-4 p-5 md:flex-row">
                <a href="/"><img className="w-40" src={logo} alt="Virtuous LOGO" /></a>
                <a href="/" className="flex items-center gap-4 cta cta-primary">
                <p>All tools</p>
                <i className="ph-caret-right"></i>
                </a>
            </div>
        </header>
    <main
    className="container relative flex flex-col flex-auto gap-8 p-8 mx-auto my-8 md:p-10 card ">
    {/*Action Top*/}
    <div className="flex flex-col justify-center gap-4 md:flex-row">
        <div className="flex flex-row gap-4">
            <img src={organolepticImg} alt="Organoleptic profile surveys"
                className="w-40 h-40 p-4 bg-gray-100 rounded-full" />
        </div> 
        <div>
            <h1 className="font-bold uppercase ">Organoleptic trial</h1>
            <h2 className="font-bold text-gray-500 uppercase ">Help us improve by telling us what you taste.</h2>
        </div>
    </div>
    {/*container*/}
    <div className="flex flex-col w-full gap-4 mx-auto mt-5 space-y-6 lg:w-2/3">

        <Dropdown title="Choose a food sample" options={["Oil sample","Wine sample", "Custom sample"]} />

        <RangeBar titles={["Bitter", "Sweet", "Salty", "Sour"]} />
        
    </div>
    {/*Action bottom*/}
    <div className="mx-auto">
        <Link to="/thanks" className="cta cta-primary">Submit</Link>
    </div>
</main>     
</div>
{/* Scripts */}
}

export default Organoleptic;